import { useState, useRef } from 'react'

// material-ui
import { useTheme } from '@mui/material/styles'
import Avatar from '@mui/material/Avatar'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import ClickAwayListener from '@mui/material/ClickAwayListener'
import List from '@mui/material/List'
import ListItemButton from '@mui/material/ListItemButton'
import ListItemIcon from '@mui/material/ListItemIcon'
import ListItemText from '@mui/material/ListItemText'
import Paper from '@mui/material/Paper'
import Popper from '@mui/material/Popper'
import Typography from '@mui/material/Typography'

// project imports
import MainCard from 'components/cards/MainCard'
import Transitions from 'components/extended/Transitions'
import User1 from 'assets/images/users/user-round.svg'

// assets
import { IconLogout, IconChevronDown } from '@tabler/icons-react'

import { useDispatch, useSelector } from 'react-redux'
import { setUser } from 'store/authReducer'
import Auth from '@aetosky/auth'

const ProfileSection = () => {
  const theme = useTheme()
  const dispatch = useDispatch()
  const currentUser = useSelector((state) => state.auth.user)

  const [open, setOpen] = useState(false)
  const anchorRef = useRef(null)

  const handleLogout = async () => {
    try {
      await Auth.getInstance().logout()
      dispatch(setUser(null))
    } catch (error) {
      dispatch(setUser(null))
      console.error(error)
    }
  }

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen)
  }

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return
    }
    setOpen(false)
  }

  return (
    <>
      <Button
        ref={anchorRef}
        onClick={handleToggle}
        sx={{
          padding: '8px',
          textTransform: 'none'
          // background: theme.palette.background.paper
        }}
        endIcon={<IconChevronDown size="1rem" color={theme.palette.text.primary} />}
      >
        <Avatar
          src={currentUser?.picture || User1}
          sx={{
            width: '34px',
            height: '34px',
            marginRight: '8px',
            backgroundColor: theme.palette.background.paper,
            color: theme.palette.text.primary,
            border: `1px solid ${theme.palette.divider}`
          }}
        />
        <Typography variant="subtitle1">{currentUser?.name || 'User'}</Typography>
      </Button>
      <Popper
        placement="bottom-end"
        open={open}
        anchorEl={anchorRef.current}
        role={undefined}
        transition
        disablePortal
        popperOptions={{
          modifiers: [
            {
              name: 'offset',
              options: {
                offset: [0, 14]
              }
            }
          ]
        }}
      >
        {({ TransitionProps }) => (
          <Transitions in={open} {...TransitionProps}>
            <Paper>
              <ClickAwayListener onClickAway={handleClose}>
                <MainCard border={false} elevation={16} content={false} boxShadow shadow={theme.shadows[16]}>
                  <Box width={200}>
                    <List component="nav">
                      <ListItemButton onClick={handleLogout}>
                        <ListItemIcon>
                          <IconLogout stroke={1.5} size="1.3rem" color={theme.palette.text.primary} />
                        </ListItemIcon>
                        <ListItemText primary={<Typography variant="body2">Logout</Typography>} />
                      </ListItemButton>
                    </List>
                  </Box>
                </MainCard>
              </ClickAwayListener>
            </Paper>
          </Transitions>
        )}
      </Popper>
    </>
  )
}

export default ProfileSection
